// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"50cae9f9","879":"9d3ff494"}[chunkId] + ".chunk.js";
};